import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';

import { RdsCodesTableComponent } from './codes-table.component';

@NgModule({
  imports: [ CommonModule, MatListModule, MatTableModule, MatPaginatorModule ],
  declarations: [RdsCodesTableComponent],
  exports: [RdsCodesTableComponent]
})
export class RdsCodesTableModule { }

export * from './codes-table.component';
